import { put, takeEvery } from "redux-saga/effects";
import { authorizedApi } from "tools/apiConfigurator";
import { formatDateString } from "safervpn-storybook/src/tools/date";
import * as actions from "./organizationsGetActions";

function makePartialSearchParams(params) {
  if (params.q) {
    return {
      ...params,
      q: JSON.stringify({ name: params.q }),
      qType: "partial",
    };
  }
  return params;
}

function* organizationsGet({ searchParams }) {
  try {
    let response = yield authorizedApi
      .get(`organizations`, {
        searchParams: makePartialSearchParams(searchParams),
      })
      .json();
    response.data.accounts.data.map((node) => {
      node.createdAtFormattedDate = formatDateString(
        node.createdAt,
        "without-time"
      );
      node.createdAtFormattedTime = formatDateString(
        node.createdAt,
        "only-time"
      );
      return node;
    });
    yield put(actions.requestSuccess(response.data));
  } catch (e) {
    yield put(actions.requestFailure(e));
  }
}

function* saga() {
  yield takeEvery(actions.ORGANIZATIONS_GET_REQUEST, organizationsGet);
}

export default saga;
